import { client } from './client'
import {
  CommissionPreview,
  CommissionSettlement,
  CreateSettlementPayload,
  DeleteSettlementResult,
  ExecutiveOption
} from '@views/executiveCommissions/types'

const headers = (cocap: string) => ({ cocap })

export const getCommissionExecutives = async (cocap: string): Promise<ExecutiveOption[]> => {
  const response = await client.get('/executive-commissions/executives', {
    headers: headers(cocap)
  })
  return response.data.data
}

export const getCommissionPreview = async (
  cocap: string,
  period: string,
  executiveId?: string
): Promise<CommissionPreview> => {
  const response = await client.get('/executive-commissions/preview', {
    headers: headers(cocap),
    params: { period, executiveId }
  })
  return response.data
}

export const getCommissionSettlements = async (
  cocap: string,
  period: string,
  executiveId?: string
): Promise<CommissionSettlement[]> => {
  const response = await client.get('/executive-commissions/settlements', {
    headers: headers(cocap),
    params: { period, executiveId }
  })
  return response.data.data
}

export const createCommissionSettlement = async (
  cocap: string,
  payload: CreateSettlementPayload
): Promise<CommissionSettlement> => {
  const response = await client.post('/executive-commissions/settlements', payload, { headers: headers(cocap) })
  return response.data
}

export const getCommissionSettlement = async (cocap: string, settlementId: string): Promise<CommissionSettlement> => {
  const response = await client.get(`/executive-commissions/settlements/${settlementId}`, {
    headers: headers(cocap)
  })
  return response.data
}

export const deleteCommissionSettlement = async (
  cocap: string,
  settlementId: string,
  reason: string
): Promise<DeleteSettlementResult> => {
  const response = await client.delete(`/executive-commissions/settlements/${settlementId}`, {
    headers: headers(cocap),
    data: { reason }
  })
  return response.data
}
